/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
import { usePromiseTracker } from 'react-promise-tracker'
import LoadingOverlay from 'react-loading-overlay-ts'
import { Oval } from 'react-loader-spinner'

export const LoadingSpinerDataComponent = () => {
  return (
    <LoadingOverlay
      className="position-inherit w-100 h-100 h-full"
      styles={{
        overlay: (base: any) => ({
          ...base,
          height: document.body.scrollHeight,
          background: 'rgb(255,255,255)'
        })
      }}
      active={true}
      spinner={<LoaderItem />}
    />
  )
}

const LoaderItem = () => {
  return <Oval color="#0033A2" secondaryColor="#0033A2" height={100} width={100} />
}
